var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-change-style" },
    [
      _c(
        "div",
        { staticClass: "rb-change-style__logo" },
        [_vm._t("change-style-logo")],
        2
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "rb-change-style__cta",
          on: { click: _vm.onChangeStylePanelClick },
        },
        [
          _vm._t("change-style-button-label"),
          _vm._v(" "),
          _c("rb-lazy-icon", { attrs: { icon: "caret-big-right" } }),
        ],
        2
      ),
      _vm._v(" "),
      _c("rb-teleport", { attrs: { selector: ".rb-pdp" } }, [
        _c(
          "div",
          { staticClass: "rb-change-style__panel" },
          [
            _c(
              "rb-panel",
              {
                attrs: { visible: _vm.panelIsVisible },
                on: { closed: _vm.onClosePanel },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [_vm._t("change-style-button-label")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rb-change-style__list" },
                  [_vm._t("change-style-panel-content")],
                  2
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }